var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui active small modal",
    attrs: {
      "id": "intro-modal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Important Note")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui positive button",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("OK")])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n      This simulator does not support Timer and Serial programs.\n      So, registers related to those programs will not work as expected.\n      They are treated as normal registers.\n    ")]), _vm._v(" "), _c('pre', [_c('code', [_vm._v("HERE: JNB P0.0 HERE")])]), _vm._v(" "), _c('p', [_vm._v("\n      Infinitely looping code, such as the one above, which relies on external input(s) to\n      break the loop "), _c('strong', [_vm._v("will")]), _vm._v(" hang the site, prompting you to reload the site.\n    ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f3e8425"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IntroModal.vue
// module id = 84
// module chunks = 1